export default "__VITE_ASSET__Mgmbnikl__"